import { postInstalmentRequest } from '../../../../../../resources/contract/actions';
import { AllTranslationKeys } from '../../../../../../shared/intl/types';
import { useGetEmptyInstalment } from '../../../../../../resources/contract/hooks';

import {
    InstalmentModalActions,
    Props as InstalmentModalActionsProps,
} from './InstalmentModalActions';

type AddInstalmentModalProps = Omit<
    InstalmentModalActionsProps,
    'title' | 'submitTextButton' | 'instalment' | 'submitAction'
> & {
    type: string;
    currency: string;
};

export const AddInstalmentModal = (props: AddInstalmentModalProps) => {
    const { type, currency, ...restProps } = props;
    const { contractId } = props;

    const instalment = useGetEmptyInstalment(type, contractId, currency);

    return (
        <InstalmentModalActions
            {...restProps}
            title={`contract.payment_schedule.modal.title.new_${type}` as AllTranslationKeys}
            submitTextButton="contract.payment_schedule.modal.submit.create"
            instalment={instalment}
            submitAction={postInstalmentRequest}
        />
    );
};
